import { AfterViewInit, Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AuthService } from 'src/app/services/auth.service';
import { GhiseuModuleService } from '../ghiseu-module.service';
import { helper } from 'src/environments/helper';
import { catchError, finalize, forkJoin, map, of, Subject, takeUntil } from 'rxjs';
import { MatButtonToggleChange } from '@angular/material/button-toggle';
import { TimeData } from '../ghiseu-module.interface';
import { TipProgramActiveService } from '../../tip-program-active/tip-program-active.service';
import { ModLocServiciiService } from '../../mod-loc-servicii/mod-loc-servicii.service';
import { NotificationService } from 'src/app/services/notification.service';
import { AbstractControl, FormBuilder, FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { MatDatepicker } from '@angular/material/datepicker';
import { TipProblemaServiciiService } from '../../tip-problema-servicii/tip-problema-servicii.service';
import { dateRangeValidator } from 'src/app/utils/common/validators/date-period';
import { notDefaultValidator } from 'src/app/shared/validators/not-default';
import { TipProgramActive } from '../../tip-program-active/tip-program-active.interface';
import { environment } from 'src/environments/environment';
import { TipProgramService } from '../../tip-program/tip-program.service';
import Swal from 'sweetalert2';

@Component({
    selector: 'app-programare-modul',
    templateUrl: './programare-modul.component.html',
    styleUrls: ['./programare-modul.component.scss']
})
export class ProgramareModulComponent implements OnInit, OnDestroy {
    // general error
    errorTitle: string = helper.dialogConfig.headers.errorAtentie;
    errorIcon: string = helper.dialogConfig.icons.error;
    errorType: string = helper.dialogConfig.icons.error;
    helper = helper;
    selectedToggleStatus = 'configurare';

    stateRows: any[] = [];
    functiiOperator$: any = [];
    functiiSelected: any[] = [];
    serviciiIds: any[] = [];
    cerereTypeIds: any[] = [];
    dataPermisiuni: any;

    configData: any;

    tipuriProgramModul: any[] = [];
    locatiiServiciiActive: any[] = [];
    timeData: TimeData[] = [];
    tipuriProgramByServiciu: { [id: number]: any[] } = {};
    filteredLocatiiServiciiMap: { [key: string]: any } = {};
    formGroupsMap: { [id: string]: FormGroup } = {};

    tipuriProblemaServiciiActive: any[] = [];

    minDatePickers: { [id: number]: MatDatepicker<any> } = {};
    maxDatePickers: { [id: number]: MatDatepicker<any> } = {};

    durataOptions: { name: string; value: number }[] = [
        // { name: '--Alegeți--', value: -1 },
        { name: '5 minute', value: 5 },
        { name: '10 minute', value: 10 },
        { name: '15 minute', value: 15 },
        { name: '20 minute', value: 20 },
        { name: '25 minute', value: 25 },
        { name: '30 minute', value: 30 },
        { name: '35 minute', value: 35 },
        { name: '40 minute', value: 40 },
        { name: '45 minute', value: 45 },
        { name: '50 minute', value: 50 },
        { name: '55 minute', value: 55 },
        { name: '60 minute', value: 60 },
    ]

    timeCursors: {
        [key: string]: { hour: string; minute: string };
    } = {};

    private destroy$ = new Subject<void>();

    selectedHour: string = '08';
    possibleHours = ['08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18'];

    selectedMinute: string = '00';
    possibleMinutesMap: { [key: string]: string[] } = {};

    selectedDayID = 1;
    daysOfWeek = [
        {
            id_day: 1,
            day: "Luni",
        },
        {
            id_day: 2,
            day: "Marți",
        },
        {
            id_day: 3,
            day: "Miercuri",
        },
        {
            id_day: 4,
            day: "Joi",
        },
        {
            id_day: 5,
            day: "Vineri",
        },
        {
            id_day: 6,
            day: "Sâmbătă",
        },
        {
            id_day: 0,
            day: "Duminică",
        },
    ];

    isLoading = false;
    moduleId: number = this.data.moduleData.id_modul;
    moduleName: string = this.data.moduleData.denumire_modul;
    locatieId: number = this.data.moduleData.id_locatie;
    locatieName: string = this.data.moduleData.denumire_locatie;
    token!: string;

    tipuriProgram!: any[];

    form: FormGroup = new FormGroup({
        id_program_type: new FormControl('-1', [Validators.required, notDefaultValidator('-1')]),
        durata_interval_blocare: new FormControl(-1, [Validators.required, Validators.min(0)]),
        durata_programare: new FormControl(-1, [Validators.required, Validators.min(0)]),
        max_date_available: new FormControl('', [Validators.required]),
        min_date_available: new FormControl('', [Validators.required]),
    }, { validators: dateRangeValidator('min_date_available', 'max_date_available') });

    formsByServiciu: { [serviciuId: number]: FormGroup } = {};

    createFormForServiciu(serviciuId: number): FormGroup {
        if (this.formsByServiciu[serviciuId]) return this.formsByServiciu[serviciuId];

        const form = new FormGroup({
            id_program_type: new FormControl('-1', [Validators.required, notDefaultValidator('-1')]),
            durata_interval_blocare: new FormControl(-1, [Validators.required, Validators.min(0)]),
            durata_programare: new FormControl(-1, [Validators.required, Validators.min(0)]),
            min_date_available: new FormControl('', [Validators.required]),
            max_date_available: new FormControl('', [Validators.required]),
        }, {
            validators: dateRangeValidator('min_date_available', 'max_date_available')
        });

        this.formsByServiciu[serviciuId] = form;
        return form;
    }

    constructor(
        @Inject(MAT_DIALOG_DATA)
        public data: any,
        private dialogRef: MatDialogRef<ProgramareModulComponent>,
        private ghiseuModuleService: GhiseuModuleService,
        private authService: AuthService,
        private tipProgramActiveService: TipProgramActiveService,
        private moduleLocatiiServiciiActiveService: ModLocServiciiService,
        private tipProblemaServiciiActiveService: TipProblemaServiciiService,
        private notificationService: NotificationService,
        private fb: FormBuilder,
        private tipProgramService: TipProgramService
    ) {
        this.processToken();
        console.log(this.data)

    }

    ngOnInit(): void {
        this.loadProgramLocatii();
        this.loadTipuriProgram();
    }

    // ngAfterViewInit(): void {
    //     this.tipuriProgramModul.forEach(tip => {
    //         const key = `${tip.id_serviciu}_${tip.id_program_type}`;
    //         const group = this.formGroupsMap[key];

    //         if (group) {
    //             group.get('durata_programare')?.valueChanges
    //                 .pipe(takeUntil(this.destroy$))
    //                 .subscribe(value => {
    //                     if (value != null) {
    //                         this.generateMinuteProgramare(value, key);
    //                     }
    //                 });
    //         }
    //     });
    // }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    groupTipuriProgramByServiciu() {
        this.tipuriProgramByServiciu = {};

        if (!this.tipuriProgramModul) return;

        for (const tip of this.tipuriProgramModul) {
            const id = tip.id_serviciu;
            if (!this.tipuriProgramByServiciu[id]) {
                this.tipuriProgramByServiciu[id] = [];
            }
            this.tipuriProgramByServiciu[id].push(tip);
        }
    }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    processToken() {
        const tokenObj = this.authService.returnTokenUser();
        tokenObj.then((token) => {
            this.token = token;
            this.ghiseuModuleService.setToken(token);
        });
    }

    onToggleChange(event: MatButtonToggleChange) {
        this.selectedToggleStatus = event.value;
    }

    setupForms() {
        this.formGroupsMap = {};

        this.stateRows.forEach(row => {
            const tipuriProgram = this.tipuriProgramByServiciu[row.id] || [];

            tipuriProgram.forEach((program: any) => {
                const key = `${row.id}_${program.id_program_type}`;

                this.formGroupsMap[key] = this.fb.group({
                    durata_programare: [
                        program.durata_programare ?? null,
                        [Validators.required, Validators.min(0)],
                    ],
                    durata_interval_blocare: [
                        program.durata_interval_blocare ?? null,
                        [Validators.required, Validators.min(0)],
                    ],
                    min_date_available: [
                        program.min_date_available ?? null,
                        Validators.required,
                    ],
                    max_date_available: [
                        program.max_date_available ?? null,
                        Validators.required,
                    ],
                }, { validators: dateRangeValidator('min_date_available', 'max_date_available') });
            });
        });

        this.tipuriProgramModul.forEach(tip => {
            const key = `${tip.id_serviciu}_${tip.id_program_type}`;
            const group = this.formGroupsMap[key];

            if (group) {
                group.get('durata_programare')?.valueChanges
                    .pipe(takeUntil(this.destroy$))
                    .subscribe(value => {
                        if (value != null) {
                            this.generateMinuteProgramare(value, key);
                        }
                    });
            }
        });
    }

    // updateCheckedList(item: any, isHeaderCheckbox: boolean = false) {
    //     let arrayToUpdate = isHeaderCheckbox ? this.serviciiIds : this.cerereTypeIds;

    //     if (item.checked) {
    //         if (!arrayToUpdate.includes(item.id)) {
    //             arrayToUpdate.push(item.id);
    //         }
    //     } else {
    //         const index = arrayToUpdate.indexOf(item.id);
    //         if (index > -1) {
    //             arrayToUpdate.splice(index, 1);
    //         }
    //     }

    //     this.configData.forEach((group: any) => {
    //         if (group.cereri_types.length > 0) {
    //             let totalItems = group.cereri_types.length;
    //             let selectedCount = group.cereri_types.filter((cerere: any) => this.cerereTypeIds.includes(cerere.id)).length;
    //             group.label = `${group.label.split('(')[0].trim()} (Selectate: ${selectedCount} / Total: ${totalItems})`;

    //             const correspondingRow = this.stateRows.find((row: any) => row.id === group.id);
    //             if (correspondingRow) {
    //                 correspondingRow.label = group.label;
    //             }
    //         }
    //     });

    //     if (isHeaderCheckbox) {
    //         // If it's a header checkbox, select/deselect all subitems without expanding/collapsing the panel
    //         item.cereri_types.forEach((cerere: any) => {
    //             cerere.checked = item.checked;
    //             this.updateCheckedList(cerere);
    //         });
    //         return;
    //     }
    // }

    // Înlocuiește metoda updateCheckedList cu aceasta:

    updateCheckedList(item: any, isHeaderCheckbox: boolean = false) {
        if (isHeaderCheckbox) {
            // Checkbox-ul serviciului
            if (item.checked) {
                if (!this.serviciiIds.includes(item.id)) {
                    this.serviciiIds.push(item.id);
                }
            } else {
                const index = this.serviciiIds.indexOf(item.id);
                if (index > -1) {
                    this.serviciiIds.splice(index, 1);
                }
            }

            // Selectează/deselectează toate tipurile de problemă din acest serviciu
            item.cereri_types.forEach((cerere: any) => {
                cerere.checked = item.checked;
            });
        } else {
            // Checkbox-ul unui tip de problemă
            // Găsește serviciul părinte pentru acest item
            const parentServiciu = this.stateRows.find(serviciu =>
                serviciu.cereri_types.some((c: any) => c === item)
            );

            if (parentServiciu) {
                // Verifică dacă există cel puțin un tip de problemă selectat
                const hasSelectedTypes = parentServiciu.cereri_types.some((c: any) => c.checked);

                // Auto-selectează/deselectează serviciul
                if (hasSelectedTypes && !parentServiciu.checked) {
                    parentServiciu.checked = true;
                    if (!this.serviciiIds.includes(parentServiciu.id)) {
                        this.serviciiIds.push(parentServiciu.id);
                    }
                } else if (!hasSelectedTypes && parentServiciu.checked) {
                    parentServiciu.checked = false;
                    const index = this.serviciiIds.indexOf(parentServiciu.id);
                    if (index > -1) {
                        this.serviciiIds.splice(index, 1);
                    }
                }
            }
        }

        // Update labels pentru toate serviciile
        this.stateRows.forEach(serviciu => {
            if (serviciu.cereri_types.length > 0) {
                const totalItems = serviciu.cereri_types.length;
                const selectedCount = serviciu.cereri_types.filter((cerere: any) => cerere.checked).length;

                // Păstrează label-ul original fără count-ul vechi
                const baseLabel = serviciu.original_label || serviciu.label.split('(')[0].trim();
                serviciu.label = `${baseLabel} (Selectate: ${selectedCount} / Total: ${totalItems})`;
            }
        });
    }

    loadProgramLocatii() {
        this.isLoading = true;

        const programLocatii$ = this.ghiseuModuleService.listProgramLocatii(this.moduleId, this.locatieId).pipe(
            map((results: any) => {
                const allServicii = results.data.all_servicii;
                const alocate = results.data.servicii_alocate;

                this.serviciiIds = alocate.map((item: any) => item.id);
                this.cerereTypeIds = [];

                const configData = allServicii.map((serviciu: any) => {
                    const isSelectedService = this.serviciiIds.includes(serviciu.id);
                    const alocatedEntry = alocate.find((a: any) => a.id === serviciu.id);
                    const selectedProblemTypeIds = alocatedEntry ? alocatedEntry.problem_types : [];

                    const cereri_types = (serviciu.problem_types || [])
                        .flat()
                        .map((pt: any) => {
                            const checked = selectedProblemTypeIds.includes(pt.id);
                            if (checked) this.cerereTypeIds.push(pt.id);

                            return {
                                ...pt,
                                name: pt.label,
                                checked,
                            };
                        });

                    let totalItems = cereri_types.length;
                    let selectedCount = cereri_types.filter((pt: any) => pt.checked).length;
                    let label = `${serviciu.label} (Selectate: ${selectedCount} / Total: ${totalItems})`;

                    return {
                        ...serviciu,
                        label,
                        original_label: serviciu.label,
                        checked: isSelectedService,
                        cereri_types,
                    };
                });

                return configData;
            }),
            catchError(err => {
                console.error('Error loading programLocatii', err);
                return of([]);
            })
        );

        const tipuriProgram$ = this.tipProgramActiveService.findByModule(this.moduleId).pipe(
            catchError(err => {
                console.error('Error loading tipuriProgram', err);
                return of([]);
            })
        );

        const locatiiServicii$ = this.moduleLocatiiServiciiActiveService.findByModule(this.moduleId).pipe(
            catchError(err => {
                console.error('Error loading locatiiServicii', err);
                return of([]);
            })
        );

        const modulSloturi$ = this.ghiseuModuleService.listModulSloturi(this.moduleId, this.locatieId).pipe(
            catchError(err => {
                console.error('Error loading modulSloturi', err);
                return of([]);
            })
        );

        const tipuriProblemaServiciiActive$ = this.tipProblemaServiciiActiveService.getTipuriProblemaServiciiActive().pipe(
            catchError(err => {
                console.error('Error loading tipuriProblemaServiciiActive', err);
                return of([]);
            })
        );

        forkJoin({
            configData: programLocatii$,
            tipuriProgramModul: tipuriProgram$,
            locatiiServiciiActive: locatiiServicii$,
            sloturi: modulSloturi$,
            tipuriProblemaServiciiActive: tipuriProblemaServiciiActive$,
        }).pipe(
            finalize(() => {
                this.isLoading = false;
            })
        ).subscribe(({ configData, tipuriProgramModul, locatiiServiciiActive, sloturi, tipuriProblemaServiciiActive }) => {
            this.configData = configData;
            // this.stateRows = [...configData];
            this.stateRows = configData.map((newRow: any) => {
                const oldRow = this.stateRows?.find(r => r.id === newRow.id);

                return {
                    ...newRow,
                    // Preserve expanded state, checkbox, etc.
                    expanded: oldRow?.expanded ?? false,
                    checked: oldRow?.checked ?? newRow.checked,
                    cereri_types: newRow.cereri_types.map((newType: any) => {
                        const oldType = oldRow?.cereri_types?.find((t: any) => t.id === newType.id);
                        return {
                            ...newType,
                            checked: oldType?.checked ?? newType.checked,
                            public_view: oldType?.public_view ?? newType.public_view ?? false,
                        };
                    })
                };
            });
            console.log('stateRows', this.stateRows);

            this.tipuriProgramModul = tipuriProgramModul;
            this.groupTipuriProgramByServiciu();
            console.log('tipuriProgramModul', this.tipuriProgramModul);

            this.locatiiServiciiActive = locatiiServiciiActive;
            console.log('locatiiServiciiActive', this.locatiiServiciiActive);
            this.processLocatiiServicii();
            this.setupForms();

            this.timeData = sloturi.map((program: any) => ({
                hour: program.time_from.slice(0, 2),
                minute: program.time_from.slice(3, 5),
                day: program.day_of_week,
                id_serviciu: program.id_serviciu,
                id_program_type: program.id_program_type,
                id_serviciu_program: program.id,
            }));
            console.log('timeData', this.timeData);

            const publicViewMap = new Map<string, boolean>();
            tipuriProblemaServiciiActive.forEach((item: any) => {
                publicViewMap.set(`${item.id_serviciu}_${item.id_problem_type}`, item.public_view);
            });

            // Inject `public_view` into each cerere_type
            this.stateRows.forEach(serviciu => {
                serviciu.cereri_types.forEach((cerere: any) => {
                    const key = `${serviciu.id}_${cerere.id}`;
                    cerere.public_view = publicViewMap.get(key) ?? false;
                });
            });
        });
    }

    generateMinuteProgramare(durataProgramare: number, key: string) {
        const generatedMinute: number[] = [];

        for (let currentValue = 0; currentValue < 60; currentValue += durataProgramare) {
            generatedMinute.push(currentValue);
        }

        const formattedMinutes = generatedMinute.map(minut =>
            minut < 10 ? '0' + minut.toString() : minut.toString()
        );

        this.possibleMinutesMap[key] = formattedMinutes;

        console.log('formattedMinutes', formattedMinutes);
        // Ensure cursor exists
        if (!this.timeCursors[key]) {
            this.timeCursors[key] = { hour: '08', minute: formattedMinutes[1] };
        } else {
            // If current minute is not valid anymore, reset it
            if (!formattedMinutes.includes(this.timeCursors[key].minute)) {
                this.timeCursors[key].minute = formattedMinutes[1];
            }
        }
    }

    selectDay(id_day: number) {
        this.selectedDayID = id_day;
    }

    processLocatiiServicii() {
        this.filteredLocatiiServiciiMap = {}; // clear first

        for (const tip of this.tipuriProgramModul) {
            const rowId = tip.id_serviciu;
            const programTypeId = tip.id_program_type;
            const durata = tip.durata_programare;

            const key = `${rowId}_${programTypeId}`;

            if (durata != null) {
                this.generateMinuteProgramare(durata, key);
            }

            this.filteredLocatiiServiciiMap[key] = tip;

            console.log('Processed tip:', tip);
        }
    }

    addTime(id_serviciu: number, id_program_type: number, durata_programare: number) {
        console.log('addtime', durata_programare);
        if (!durata_programare || durata_programare <= 0) {
            this.notificationService.warningSwal(
                this.errorTitle,
                'Durată programare invalidă sau lipsă.',
                this.errorIcon
            );
            return;
        }

        const key = `${id_serviciu}_${id_program_type}_${this.selectedDayID}`;

        const cursor = this.timeCursors[key] || {
            hour: this.selectedHour,
            minute: this.selectedMinute,
        };

        const newTime = {
            hour: cursor.hour,
            minute: cursor.minute,
            day: this.selectedDayID,
            id_serviciu,
            id_program_type,
            added: true,
        };

        const existingTime = this.timeData.find(time =>
            time.hour === newTime.hour &&
            time.minute === newTime.minute &&
            time.day === newTime.day &&
            time.id_serviciu === newTime.id_serviciu &&
            time.id_program_type === newTime.id_program_type
        );

        if (!existingTime) {
            this.timeData.push(newTime);
            this.increaseTime(id_serviciu, id_program_type, durata_programare);
        } else if (existingTime && existingTime.deleted === true) {
            existingTime.deleted = false;
            this.increaseTime(id_serviciu, id_program_type, durata_programare);
        } else {
            this.notificationService.warningSwal(
                this.errorTitle,
                'Ora și minutul alese sunt deja existente.',
                this.errorIcon
            );
        }

        console.log('timeData', this.timeData);
    }

    generateKey(id_serviciu: number, id_program_type: number, day: number): string {
        return `${id_serviciu}_${id_program_type}_${day}`;
    }

    initializeTimeCursor(id_serviciu: number, id_program_type: number, day: number): boolean {
        const key = this.generateKey(id_serviciu, id_program_type, day);
        if (!this.timeCursors[key]) {
            this.timeCursors[key] = { hour: '08', minute: '00' };
        }
        return true;
    }

    increaseTime(id_serviciu: number, id_program_type: number, durata_programare: number) {
        const key = `${id_serviciu}_${id_program_type}_${this.selectedDayID}`;

        let cursor = this.timeCursors[key] || {
            hour: this.selectedHour,
            minute: this.selectedMinute,
        };

        let newMinute = parseInt(cursor.minute, 10) + durata_programare;
        let newHour = parseInt(cursor.hour, 10);

        if (newMinute >= 60) {
            newMinute = 0;
            newHour += 1;

            if (newHour === 19) {
                newHour = 8;
            }
        }

        const updated = {
            hour: newHour < 10 ? '0' + newHour.toString() : newHour.toString(),
            minute: newMinute < 10 ? '0' + newMinute.toString() : newMinute.toString(),
        };

        this.timeCursors[key] = updated;
    }

    removeTime(timeIndex: number) {
        const removedTime = this.timeData[timeIndex];

        if (removedTime.added === true) {
            this.timeData.splice(timeIndex, 1);
        } else {
            this.timeData[timeIndex].deleted = true;
        }

        // Recalculate the cursor for this key based on remaining times
        const key = `${removedTime.id_serviciu}_${removedTime.id_program_type}_${removedTime.day}`;
        const relevantTimes = this.timeData
            .filter(time =>
                !time.deleted &&
                time.id_serviciu === removedTime.id_serviciu &&
                time.id_program_type === removedTime.id_program_type &&
                time.day === removedTime.day
            )
            .sort((a, b) => {
                const aMinutes = parseInt(a.hour, 10) * 60 + parseInt(a.minute, 10);
                const bMinutes = parseInt(b.hour, 10) * 60 + parseInt(b.minute, 10);
                return bMinutes - aMinutes; // latest time first
            });

        if (relevantTimes.length > 0) {
            const latest = relevantTimes[0];
            this.timeCursors[key] = {
                hour: latest.hour,
                minute: latest.minute,
            };
        } else {
            delete this.timeCursors[key]; // reset if nothing left
        }

        console.log('timeData', this.timeData);
    }

    formatDate(date: Date) {
        let d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2) month = '0' + month;
        if (day.length < 2) day = '0' + day;

        return [year, month, day].join('-');
    }

    loadTipuriProgram() {
        this.isLoading = true;
        this.tipProgramService.getTipuriProgram().pipe(
            map((results: any) => [...results.data]),
            finalize(() => (this.isLoading = false))
        ).subscribe({
            next: (res) => {
                this.tipuriProgram = res;
            },
            error: (err) => {
                console.error('Error in get tipuri program: ', err);
            }
        })
    }

    deleteTipProgram(id: number) {
        Swal.fire({
            title: helper.dialogConfig.commonTitles.areYouSure,
            text: 'Nu o să puteți recupera datele odată cu ștergerea lor!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: helper.dialogConfig.colorButtons.standard,
            confirmButtonText: helper.dialogConfig.buttonLabels.confirm,
            cancelButtonText: helper.dialogConfig.buttonLabels.close,
            showLoaderOnConfirm: true,
            reverseButtons: true,
            allowOutsideClick: false,
        }).then((result) => {
            if (result.isConfirmed) {
                // we do this because we need to have some control on activity
                this.deleteAction(id);
            }
        });
    }

    deleteAction(id: number) {
        this.isLoading = true;
        this.tipProgramActiveService.deleteTipProgramActive(id).subscribe(
            () => {
                Swal.fire({
                    title: helper.dialogConfig.headers.success,
                    text: 'Tip Program Activ șters cu succes!',
                    icon: 'success',
                    confirmButtonText: helper.dialogConfig.buttonLabels.close,
                    allowOutsideClick: false,
                }).then(() => {
                    this.loadProgramLocatii();
                });
            },
            (err) => {
                let msg;
                try {
                    // try to catch the message from server
                    msg = err.error.errors.message[0];
                } catch (error) {
                    // controll output message
                    msg = helper.dialogConfig.generalMessages.error;
                }

                Swal.fire({
                    title: helper.dialogConfig.headers.errorAtentie,
                    text: msg,
                    icon: 'success',
                    confirmButtonText: helper.dialogConfig.buttonLabels.retry,
                    showCancelButton: true,
                    cancelButtonText: helper.dialogConfig.buttonLabels.close,
                    reverseButtons: true,
                    allowOutsideClick: false,
                }).then((result) => {
                    if (result.isConfirmed) {
                        this.deleteAction(id);
                    }
                });
            }
        );
    }

    submitTipProgram(id: number) {
        this.isLoading = true;

        const form = this.formsByServiciu[id]

        const { id_program_type, durata_interval_blocare, durata_programare, min_date_available, max_date_available } = form.value as any;

        const newTipProgramActive: TipProgramActive = {
            id_modul: this.moduleId,
            id_locatie: this.locatieId,
            id_serviciu: id,
            id_program_type,
            durata_interval_blocare,
            durata_programare,
            max_date_available: max_date_available ? this.formatDate(max_date_available) : '',
            min_date_available: min_date_available ? this.formatDate(min_date_available) : '',
        };

        this.tipProgramActiveService
            .addTipProgramActive(newTipProgramActive)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: (res) => {
                    this.loadProgramLocatii();
                },
                error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }

    updateTimesModul() {
        const payload: any = {
            id_module: this.moduleId,
            id_locatie: this.locatieId,
            timeData: this.timeData,
            servicii: this.stateRows.map(serviciu => {
                const checkedTypes = (serviciu.cereri_types || [])
                    .filter((pt: any) => pt.checked)
                    .map((pt: any) => pt.id);

                const program_types = Object.entries(this.formGroupsMap)
                    .filter(([key]) => key.startsWith(`${serviciu.id}_`))
                    .map(([key, form]: [string, FormGroup]) => {
                        const id_program_type = parseInt(key.split('_')[1], 10);

                        const matchedProgram = this.tipuriProgramModul.find(
                            (p: any) => p.id_serviciu === serviciu.id && p.id_program_type === id_program_type
                        );

                        return {
                            id_program_type,
                            id_program_type_active: matchedProgram?.id ?? null,
                            durata_programare: form.get('durata_programare')?.value ?? null,
                            durata_interval_blocare: form.get('durata_interval_blocare')?.value ?? null,
                            min_date_available: form.get('min_date_available')?.value
                                ? this.formatDate(form.get('min_date_available')?.value)
                                : null,
                            max_date_available: form.get('max_date_available')?.value
                                ? this.formatDate(form.get('max_date_available')?.value)
                                : null,
                        };
                    });

                return {
                    id_serviciu: serviciu.id,
                    checked: serviciu.checked,
                    problemTypeIds: checkedTypes,
                    program_types
                };
            }),
        };

        this.ghiseuModuleService.advancedEditModul(payload)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: (res) => {
                    this.dialogRef.close({ success: true });
                },
                error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                },
            })

        console.log('payload', payload);
    }
}
